module.exports = __webpack_public_path__ + "static/media/017.0df2dc15.png";